// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 3Lirqv7FAD
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: aLOScdJViiG/component
import DocumentEntry from "../../DocumentEntry"; // plasmic-import: yje-V7KktC/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicDrivePlugin.module.css"; // plasmic-import: 3Lirqv7FAD/css

import GoogleDriveLogoSvgrepoComsvgIcon from "./icons/PlasmicIcon__GoogleDriveLogoSvgrepoComsvg"; // plasmic-import: O2JLipFgAu/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YgxDZcg-ug-/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: tWUxgGBbs9p/icon

export type PlasmicDrivePlugin__VariantMembers = {};

export type PlasmicDrivePlugin__VariantsArgs = {};
type VariantPropType = keyof PlasmicDrivePlugin__VariantsArgs;
export const PlasmicDrivePlugin__VariantProps = new Array<VariantPropType>();

export type PlasmicDrivePlugin__ArgsType = {};
type ArgPropType = keyof PlasmicDrivePlugin__ArgsType;
export const PlasmicDrivePlugin__ArgProps = new Array<ArgPropType>();

export type PlasmicDrivePlugin__OverridesType = {
  root?: p.Flex<"div">;
  googleLogin?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  text?: p.Flex<"div">;
  linkButton?: p.Flex<typeof Button>;
  links?: p.Flex<"div">;
};

export interface DefaultDrivePluginProps {
  className?: string;
}

function PlasmicDrivePlugin__RenderFunc(props: {
  variants: PlasmicDrivePlugin__VariantsArgs;
  args: PlasmicDrivePlugin__ArgsType;
  overrides: PlasmicDrivePlugin__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"googleLogin"}
        data-plasmic-override={overrides.googleLogin}
        className={classNames(projectcss.all, sty.googleLogin)}
      />

      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__qviqB)}
      >
        <GoogleDriveLogoSvgrepoComsvgIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg)}
          role={"img"}
        />

        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          {"Google Drive Links"}
        </div>

        <div className={classNames(projectcss.all, sty.freeBox___6Pjv)}>
          <Button
            data-plasmic-name={"linkButton"}
            data-plasmic-override={overrides.linkButton}
            className={classNames("__wab_instance", sty.linkButton)}
            color={"softSand" as const}
            size={"compact" as const}
          >
            {"Add"}
          </Button>
        </div>
      </p.Stack>

      <p.Stack
        as={"div"}
        data-plasmic-name={"links"}
        data-plasmic-override={overrides.links}
        hasGap={true}
        className={classNames(projectcss.all, sty.links)}
      >
        <DocumentEntry
          className={classNames("__wab_instance", sty.documentEntry__oMLol)}
        />

        <DocumentEntry
          className={classNames("__wab_instance", sty.documentEntry___37Kn5)}
        />

        <DocumentEntry
          className={classNames("__wab_instance", sty.documentEntry__tprBw)}
        />

        <DocumentEntry
          className={classNames("__wab_instance", sty.documentEntry__yhVof)}
        />

        <DocumentEntry
          className={classNames("__wab_instance", sty.documentEntry__t8ZyN)}
        />

        <DocumentEntry
          className={classNames("__wab_instance", sty.documentEntry__fGlfl)}
        />
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "googleLogin", "svg", "text", "linkButton", "links"],
  googleLogin: ["googleLogin"],
  svg: ["svg"],
  text: ["text"],
  linkButton: ["linkButton"],
  links: ["links"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  googleLogin: "div";
  svg: "svg";
  text: "div";
  linkButton: typeof Button;
  links: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDrivePlugin__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDrivePlugin__VariantsArgs;
    args?: PlasmicDrivePlugin__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicDrivePlugin__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicDrivePlugin__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicDrivePlugin__ArgProps,
          internalVariantPropNames: PlasmicDrivePlugin__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicDrivePlugin__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDrivePlugin";
  } else {
    func.displayName = `PlasmicDrivePlugin.${nodeName}`;
  }
  return func;
}

export const PlasmicDrivePlugin = Object.assign(
  // Top-level PlasmicDrivePlugin renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    googleLogin: makeNodeComponent("googleLogin"),
    svg: makeNodeComponent("svg"),
    text: makeNodeComponent("text"),
    linkButton: makeNodeComponent("linkButton"),
    links: makeNodeComponent("links"),

    // Metadata about props expected for PlasmicDrivePlugin
    internalVariantProps: PlasmicDrivePlugin__VariantProps,
    internalArgProps: PlasmicDrivePlugin__ArgProps
  }
);

export default PlasmicDrivePlugin;
/* prettier-ignore-end */
